<div class="distribution-list-edit-page">
  <div
    fxLayout="row"
    fxLayoutAlign="start center">
    <div
      class="return-menu-item"
      fxLayout="row"
      fxLayoutAlign="start center"
      routerLink="/communications/distribution-lists">
      <div><i class="icon icon-arrow_return"></i></div>
      <div class="menu-item-label">{{ 'MANAGEMENT.COMMUNICATION-CENTER.RETURN-TO-DISTRIBUTION-LISTS' | translate }}</div>
    </div>
  </div>
  <div
    fxLayout="row"
    fxLayoutAlign="space-between center">
    <div
      fxLayout="row"
      fxLayoutAlign="start center"
      class="mt-3">
      <img
        style="margin-right: 8px"
        src="/assets/images/people-group.svg" />
      <h3>{{ distributionList?.name }}</h3>
    </div>
    @if (!readonlyMode) {
      <div
        fxLayout="row"
        >
        <button
          class="button is-secondary is-medium mr-2"
          (click)="cancelClick()">
          {{ 'MANAGEMENT.COMMUNICATION-CENTER.CANCEL' | translate }}
        </button>
        <button
          class="button is-primary is-medium"
          (click)="saveClick()">
          {{ 'MANAGEMENT.COMMUNICATION-CENTER.SAVE' | translate }}
        </button>
      </div>
    }
  </div>
  <div
    fxLayout="row"
    class="mt-3">
    @if (!readonlyMode) {
      <div
        style="width: 440px"
        class="mr-6">
        <div
          style="width: 100%"
          class="mb-4">
          <topo-tabs
            [selectedTabIndex]="selectedTabIndex"
            [tabs]="tabs"
          (selectedTabIndexChanged)="tabChange($event)"></topo-tabs>
        </div>
        <!-- Sidebar Section -->
        @if (selectedTabIndex === 0) {
          <form>
            <div class="field">
              <label>{{ 'MANAGEMENT.COMMUNICATION-CENTER.NAME' | translate }}</label>
              <div>
                <input
                  class="input is-fullwidth"
                  type="text"
                  placeholder="{{ 'MANAGEMENT.COMMUNICATION-CENTER.NAME' | translate }}"
                  [(ngModel)]="distributionList.name"
                  name="name" />
              </div>
            </div>
            <div class="field">
              <label>{{ 'MANAGEMENT.COMMUNICATION-CENTER.DESCRIPTION' | translate }}</label>
              <div>
                <textarea
                  name="description"
                  class="textarea"
                  placeholder="{{ 'MANAGEMENT.DATAFEEDS.DESCRIPTION' | translate }}"
                [(ngModel)]="distributionList.description"></textarea>
              </div>
            </div>
            @if (hasBusinessUnits) {
              <div
                class="field"
                >
                <label>{{ 'COMMUNICATIONS.BUSINESS-UNITS' | translate }}</label>
                <div
                  class="business-units"
                  [ngClass]="{ 'disabled': !(businessUnits?.length > 0) }">
                  <topo-business-unit-select
                    [multiSelectionMode]="true"
                    [selectedUIds]="selectedUnitUIds"
                    [businessUnits]="businessUnits"
                    location="right"
                  (selectedChanged)="onBusinessUnitsSelectionChanged($event)"></topo-business-unit-select>
                </div>
              </div>
            }
            <div class="field">
              <label>{{ 'MANAGEMENT.COMMUNICATION-CENTER.DATASET' | translate }}</label>
              <div>{{ dataset?.name }}</div>
            </div>
          </form>
        }
        @if (selectedTabIndex === 1) {
          <topo-filter-display
            [filterGroup]="filterGroup"
            [schema]="dataset?.schema"
            [workflow]="dataset?.workflow"
            actionIfDescription="FILTERS.PREFIX.IF"
            actionResultDescription="FILTERS.POSTFIX.DISTRIBUTION-LIST"
            (filterChanged)="filterChanged($event)"
          [maxLength]="175"></topo-filter-display>
        }
      </div>
    }
    <div [ngStyle]="{ 'width': readonlyMode === true ? '100%' : '90%' }">
      <!-- Table Section -->
      <div class="mb-6">
        <topo-data-table-server
          [isActive]="true"
          [embedded]="true"
          [datasource]="datasource"
          [columns]="columDefs"
          headerLabel="{{ 'MANAGEMENT.DATASETS.RECORDS' | translate }}"
          [showNewButton]="false"
          [showHeader]="true"
          [showSearch]="true"
          [showRowGroups]="false"
          [showMenu]="false"
          [showDownload]="userContextService.canReadDistributionList() && totalCount <= RECORD_LIMIT"
          (exportToExcel)="downloadDistributionListCSV($event)"
          [height]="420"
          [showSystemFields]="true"
          (paginate)="onPaginate($event)"
          (takeChanged)="onTakeChanged($event)"
          [skip]="skip"
          [take]="take"
        [totalCount]="totalCount"></topo-data-table-server>
      </div>
    </div>
  </div>

  <ngx-spinner
    id="map-spinner"
    bdColor="rgba(0,0,0,.3)"
    size="medium"
    color="var(--primary-color-600)"
    type="ball-spin-fade"
    [fullScreen]="false"
    name="dist-list"
    [zIndex]="998" />
</div>
<!-- Recipient Detail View RSD -->
<topo-right-drawer [isOpen]="isRightDrawerOpen">
  <div class="dataset-form-runtime">
    <div
      class="px-4 py-5"
      fxLayout="row">
      <h5>{{ 'COMMUNICATIONS.RECIPIENT-DETAILS' | translate: { name: dataset?.name } }}</h5>
    </div>
    @if (!!selectedDocument) {
      <div
        class="document-edit px-5"
        style="margin-top: 10px; margin-bottom: 10px">
        <div
          topoDynamicForm
          [formView]="editDocumentView"
          [schema]="dataset?.schema"
          [document]="selectedDocument"
          [controlCollection]="documentControls"
          [isEdit]="false"
          [dataset]="dataset"
        [layerUId]="guidEmpty"></div>
        <div style="height: 100px">&nbsp;</div>
      </div>
    }
    <div
      class="bottom-button-bar px-3"
      fxLayout="row"
      fxLayoutAlign="center center">
      <button
        class="button is-secondary cancel"
        (click)="closeDocumentClick()">
        {{ 'COMMUNICATIONS.BUTTONS.CLOSE' | translate }}
      </button>
    </div>
  </div>
</topo-right-drawer>
